import http from "../../utils/http"

/**
 * ดูรายการความช่วยเหลือ
 */
export function helpList(params) {
    return http({
        url: "/api/helpclass/lists",
        data: params
    })
}
/**
 * ดูรายละเอียดความช่วยเหลือ
 */
export function helpDetail(params) {
    return http({
        url: "/api/help/info",
        data: params
    })
}
/**
 * ดูรายละเอียดความช่วยเหลือ
 */
export function helpOther(params) {
    return http({
        url: "/api/help/page",
        data: params
    })
}
